import { useRouter } from 'next/navigation'
import { useEffect, useLayoutEffect } from 'react'
import { ComponentDynamicRedirect } from '../../../../../models/types'
import { RcLoader } from '@/components/atoms/RcLoader'
import { useOrganization } from '@/entity/organization/useOrganization'

export const Redirect = ({
  path,
  replace,
  skipScroll,
  skipRedirect,
  height
}: Partial<ComponentDynamicRedirect> & {
  replace?: boolean
  skipScroll?: boolean
  skipRedirect?: boolean
  height?: string | number | undefined
}) => {
  const router = useRouter()
  useLayoutEffect(() => {
    if (skipRedirect) return
    if (!path) return
    if (replace) {
      router.replace(path, { scroll: !skipScroll })
    } else {
      router.push(path, { scroll: !skipScroll })
    }
  }, [path, replace, router, skipScroll, skipRedirect])

  return skipRedirect ? (
    <>
      {path
        ? `If you were a normal user this would redirect you to ${path}`
        : '^ click that gear to configure redirect'}
    </>
  ) : (
    <RcLoader height={height} />
  )
}
